export default {
	sidebar: {
		dashboard: 'Übersicht',
		articles: 'Artikel',
		shop: 'Shop',
		cart: 'Warenkorb',
		orders: 'Bestellungen',
		delivery: 'Lieferung',
		locations: 'Standorte',
		//
		seller_header: 'Anbieter/in',
		seller_articles: 'Artikel',
		seller_orders: 'Bestellungen',
		seller_order_items: 'Bestellpositionen',
		seller_delivery: 'Lieferung',
		seller_map: 'Karte',
		//
		event_header: 'Veranstaltung',
		event_articles: 'Artikel',
		event_orders: 'Bestellungen',
		event_order_items: 'Bestellpositionen',
		event_delivery: 'Lieferung',
		event_map: 'Karte',
		//
		settings_header: 'Einstellungen',
		admin_header: 'Administration',
		event_settings: '{event_name}',
		team_settings: '{team_name}',
		//
		no_event_selected: 'Kein Event ausgewählt',
		no_team_selected: 'Kein Team ausgewählt',
	},
	// Kurze Titel (Tooltips) für Buttons ohne sichtbare Beschriftung, vor allem für die
	// Aktionen in den Tabellen. Nur wenige Worte, damit klar ist was der Button macht.
	buttons: {
		article: {
			create: 'Artikel anlegen',
			copy: 'Artikel kopieren',
			edit: 'Artikel bearbeiten',
			show: 'Artikel ansehen',
			delete: 'Artikel löschen',
			open: 'Artikel öffnen',
			release: 'Zur Prüfung freigeben',
			release_info: 'Warum keine Freigabe?',
			accept: 'Zur Bestellung freigeben',
			add_dependent: 'Abhängigen Artikel hinzufügen',
			remove_dependent: 'Abhängigen Artikel entfernen',
			add_file: 'Datei hinzufügen',
			remove_file: 'Datei entfernen',
		},
		article_category: {
			create: 'Kategorie anlegen',
			delete: 'Kategorie löschen',
		},
		order: {
			create: 'Bestellung anlegen',
			edit: 'Bestellung bearbeiten',
			show: 'Bestellung ansehen',
			delete: 'Bestellung löschen',
			open: 'Bestellung öffnen',
			shop: 'Zum Shop',
			cart: 'Zum Warenkorb',
		},
		order_item: {
			list: 'Zu den Bestellpositionen',
			create: 'Position hinzufügen',
			price: 'Preis eintragen',
			confirm: 'Position bestätigen',
			edit: 'Position bearbeiten',
			switch: 'Artikel tauschen',
			refuse: 'Position ablehnen',
			accept_price: 'Preis akzeptieren',
			deliver: 'Als geliefert markieren',
			increase: 'Menge erhöhen',
			decrease: 'Menge verringern',
			delete: 'Position löschen',
			mail: 'E-Mail an Besteller/in',
		},
		location: {
			create: 'Standort anlegen',
			edit: 'Standort bearbeiten',
			delete: 'Standort löschen',
			orders: 'Bestellungen des Standorts',
		},
		team: {
			delete: 'Team entfernen',
			orders: 'Bestellungen des Teams',
			delivery_note: 'Lieferschein anzeigen',
		},
		file: {
			show: 'Datei anzeigen',
			download: 'Datei herunterladen',
		},
		map: {
			download: 'Karte herunterladen',
		},
	},
	pages: {
		articles: {
			title: 'Artikel',
		},
		article_settings: {
			published_info:
				'Der Artikel ist zur Prüfung freigegeben. Um diesen noch zu ändern deaktiviere die Freigabe in der Artikelübersicht.',
			accepted_info:
				'Der Artikel ist zur Bestellung freigeben. Eine Bearbeitung des Artikels ist nicht mehr möglich.',
		},
		dashboard: {
			title: 'Willkommen bei Event Order Pro',
			show_days: 'Veranstaltungszeitraum',
			production_days: 'Produktionszeitraum',
			order_days: 'Bestellzeitraum',
			text: 'Hier kannst du deine Bedarfe für die Veranstaltung bestellen.',
			shipping_address: 'Lieferadresse:',
			buttons: {
				to_shop: 'Zum Shop',
				to_articles: 'Zu den angebotenen Artikeln',
				new_article: 'Jetzt neuen Artikel erstellen',
			},
			todos: {
				title: 'Meine Aufgaben',
				no_todos: 'Keine offenen Aufgaben',
				no_todos_hint: 'Aktuell gibt es nichts für dich zu erledigen.',
				articles_to_accept: 'Artikel die noch akzeptiert werden müssen:',
				articles_to_publish: 'Artikel die noch veröffentlicht werden müssen:',
				price_to_set: 'Preise die noch bestimmt werden müssen:',
				price_to_accept: 'Preise die noch zu akzeptieren sind:',
				cart_items_to_confirm: 'Warenkorb Positionen die noch bestätigt werden müssen:',
			},
		},
		shop: {
			ordering_start_at: 'Die Bestellung wird ab dem {date} freigeschaltet.',
			ordering_end_at: 'Die Bestellung ist bis zum {date} möglich.',
			ordering_expired:
				'Es sind keine Bestellungen mehr möglich. Bitte wenden Sie sich an ihre/n Ansprechpartner/in.',
		},
		cart: {
			id: 'Id',
			title: 'Warenkorb',
		},
		orders: {
			title: 'Bestellungen von {team}',
		},
		delivery: {
			title: 'Lieferung an {team}',
		},
		order_review: {
			title: 'Bestellung: {name}',
		},
		event: {
			orders: {
				title: 'Bestellungen - {event}',
			},
			order_items: {
				title: 'Bestellpositionen - {event}',
			},
			delivery: {
				title: 'Lieferung - {event}',
			},
		},
		seller: {
			articles: {
				title: 'Artikel',
				add: 'Neuen Artikel hinzufügen',
				edit: 'Artikel bearbeiten',
				delete: 'Artikel löschen',
				delete_confirm: 'Möchten Sie diesen Artikel wirklich löschen?',
			},
			orders: {
				title: 'Bestellungen bei {team}',
			},
			order_items: {
				title: 'Bestellpositionen bei {team}',
			},
			delivery: {
				title: 'Lieferung der Bestellpositionen von {team}',
			},
		},
		admin_settings: {
			article_categories: {
				title: 'Artikelkategorien',
			},
		},
		event_settings: {
			title: 'Veranstaltungseinstellungen',
			general: {
				address_data: 'Adressdaten',
			},
			users: {
				title: 'Personen',
				add: 'Neue Person hinzufügen',
			},
			teams: {
				title: 'Teams',
				add: 'Neues Team hinzufügen',
				delivery_note: 'Lieferschein anzeigen',
			},
			locations: {
				title: 'Einsatzorte',
				add: 'Neuen Einsatzort hinzufügen',
			},
			delivery_note: {
				title: 'Gestaltung des Lieferscheins',
				hint: 'Die Absenderadresse stammt aus den allgemeinen Einstellungen der Veranstaltung, die Empfängeradresse aus den Stammdaten des jeweiligen Teams. Der Lieferschein enthält alle gelieferten Bestellpositionen eines Teams.',
			},
			import: {
				title: 'Import',
				heading: 'Team-Import',
				intro: 'Teams, Team-Admins und Einsatzorte aus einer Excel- oder CSV-Datei anlegen.',
				open: 'Datei importieren',
				file: {
					hint: 'Excel- oder CSV-Datei mit einer Standeinheit pro Zeile. Die erste Zeile muss die Spaltenüberschriften enthalten.',
				},
				mapping: {
					no_admin_email: 'Ohne zugeordnete E-Mail-Adresse wird das Team angelegt, aber kein Team-Admin.',
				},
				block: {
					team: 'Team mit Stammdaten',
					admin: 'Team-Admin anlegen',
				},
				report: {
					admin: 'Team-Admin',
				},
				field: {
					external_id: 'Externe Id',
					team_name: 'Team Name',
					team_number: 'Team-Nummer',
					legal_name: 'Firmierung',
					street: 'Straße',
					street_number: 'Hausnummer',
					zip: 'Postleitzahl',
					city: 'Stadt',
					country: 'Land',
					vat_number: 'USt-IdNr.',
					tax_number: 'Steuernummer',
					invoice_note: 'Rechnungshinweis',
					contact_mobile: 'Mobil (Kontakt)',
					admin_firstname: 'Team-Admin: Vorname',
					admin_lastname: 'Team-Admin: Nachname',
					admin_email: 'Team-Admin: E-Mail',
				},
				subject: {
					team: 'Team',
					invitation: 'Einladung',
					admin: 'Admin',
				},
				summary: {
					teams_created: 'Teams neu',
					teams_updated: 'Teams aktualisiert',
					invitations_created: 'Einladungen',
					invitations_updated: 'Einladungen aktualisiert',
					admins_created: 'Admins neu',
					admins_attached: 'Admins verknüpft',
					admins_skipped: 'Admins übersprungen',
				},
				error: {
					missing_team_name: 'Keine Firma',
				},
				warning: {
					missing_admin_email: 'Keine E-Mail – kein Admin',
					invalid_admin_email: 'E-Mail ungültig',
					incomplete_admin_name: 'Vor- oder Nachname fehlt',
				},
			},
			locations_import: {
				title: 'Einsatzorte-Import',
				heading: 'Einsatzorte-Import',
				intro: 'Einsatzorte aus einer CSV-Datei anlegen oder aktualisieren und einem Team zuordnen.',
				open: 'Einsatzorte importieren',
				file: {
					hint: 'CSV- oder Excel-Datei mit einem Einsatzort pro Zeile. Die erste Zeile muss die Spaltenüberschriften enthalten.',
				},
				no_team_hint: 'Ohne zugeordnete Team-Nummer werden Einsatzorte angelegt, aber keinem Team zugeordnet.',
				option: {
					prefix_external_id: 'Externe ID zum Namen hinzufügen',
					prefix_external_id_hint:
						'Stellt jedem Namen die externe ID voran, damit doppelte Namen eindeutig werden.',
					only_matched_teams: 'Nur Einsatzorte mit gefundenem Team importieren',
					only_matched_teams_hint: 'Zeilen, deren Team-Nummer keinem Team entspricht, werden übersprungen.',
				},
				field: {
					external_id: 'Externe Id des Einsatzortes',
					name: 'Name des Einsatzortes',
					description: 'Beschreibung',
					team_number: 'Team-Nummer (ID Ausstellende)',
					team_name: 'Zugeordnetes Team',
				},
				subject: {
					location: 'Einsatzort',
					assignment: 'Zuordnung',
				},
				summary: {
					locations_created: 'Einsatzorte neu',
					locations_updated: 'Einsatzorte aktualisiert',
					assignments_created: 'Zuordnungen',
				},
				error: {
					name_taken: 'Name bereits vergeben',
					team_not_matched: 'Kein passendes Team',
				},
				warning: {
					team_not_found: 'Team nicht gefunden',
					team_ambiguous: 'Team-Nummer mehrdeutig',
				},
			},
		},
	},
	modals: {
		create_cart: {
			title: 'Neuen Warenkorb anlegen',
			select_existing: 'Vorhandenen Warenkorb auswählen',
		},
		upload_article_file: {
			title: 'Datei auswählen',
		},
		delete_cart: {
			title: 'Bestellung löschen',
			text: "Soll die Bestellung '{item}' wirklich gelöscht werden?",
		},
		edit_order: {
			edit: 'Bestellung editieren',
		},
		edit_article: {
			create: 'Neuen Artikel erstellen für {event_name}',
			edit: 'Artikel bearbeiten für {event_name}',
			name_duplicate: 'Dieser Artikelname wird bereits verwenden. Bitte wähle einen anderen.',
		},
		edit_article_category: {
			create: 'Neuen Artikel Kategorie erstellen',
			edit: 'Artikel Kategorie bearbeiten',
		},
		delete_article_category: {
			title: 'Artikel Kategorie löschen',
			text: "Soll die Artikelkategorie '{item}' wirklich gelöscht werden?",
			blocked: 'Kategorie kann nicht gelöscht werden, solange Artikel zugeordnet sind.',
		},
		edit_location: {
			create: 'Neuen Einsatzort erstellen für {event_name}',
			edit: 'Einsatzort editieren für {event_name}',
		},
		delete_location: {
			title: 'Einsatzort löschen',
			text: "Soll der Einsatzort '{item}' wirklich gelöscht werden?",
			blocked:
				'Einsatzort kann nicht gelöscht werden, solange Bestellungen zugeordnet sind oder die Veranstaltung gesperrt ist.',
		},
		invite_team: {
			create: 'Team zu Veranstaltung einladen',
			edit: 'Einladung des Teams anpassen',
			number: 'Zeichen',
			is_seller: 'Ist Anbieter/in',
			locations: 'Einsatzorte',
			budget_enabled: 'Budget begrenzen',
			budget: 'Budget',
			custom_ordering_enabled: 'Individuellen Bestellzeitraum aktivieren',
			ordering_start_at: 'Bestellstart',
			ordering_start_end: 'Bestellschluss',
			custom_article_categories_enabled: 'Verfügbare Arikel Kategorien einschränken',
			article_categories: 'Artikel Kategorien',
		},
		remove_team: {
			title: 'Team entfernen',
			text: "Soll das Team '{item}' wirklich von der Veranstaltung entfernt werden?",
		},
		article_order_description: {
			title: 'Bestellinformation',
		},
		edit_cart_item_pricing: {
			title: 'Preis auf Anfrage bearbeiten',
		},
		confirm_cart_item: {
			title: 'Warenkorb Position bestätigen',
			text: 'Soll diese Warenkorb Position bestätigt werden? Dieser Vorgang nicht rückgängig gemacht werden.',
			ordered: {
				from: 'Benötigt an',
				until: 'Benötigt bis',
				quantity_unit: 'Menge',
				quantity_factor: 'Faktor',
				total_price: 'Preis',
			},
			confirmed: {
				from: 'Bestätigt von',
				until: 'Bestätigt bis',
				quantity_unit: 'Bestätigte Menge',
				quantity_factor: 'Bestätigter Faktor',
				total_price: 'Preis nach Bestätigung',
			},
		},
		switch_cart_item: {
			title: 'Artikel Art der Warenkorb Position tauschen',
			text: 'Soll die Artikel Art dieser Warenkorb Position getauscht werden? Dieser Vorgang nicht rückgängig gemacht werden.',
			switch_team_warning:
				'Achtung: Die Artikel Art gehört zu einem anderen Team, nach dem Tausch verlieren sie den Zugriff auf die Warenkorb Position.',
			current_article: 'Aktueller Artikel',
			new_article: 'Neuer Artikel',
		},
		add_cart_item: {
			title: 'Artikel dem Warenkorb hinzufügen',
			text: 'Den folgende Artikel zum Warenkorb hinzufügen? Der/Die Besteller/in muss den Artikel nach hinzufügen noch annehmen.',
		},
	},
	data: {
		article: {
			id: 'Id',
			name: 'Artikelname',
			url: 'URL',
			unit: 'Einheit',
			factor: 'Faktor',
			factor_min: 'Mindestmietdauer',
			is_pickup: 'Selbstabholung',
			is_shown: 'Im Shop anzeigen',
			is_individual: 'Als mehrere Positionen im Warenkorb',
			has_fixed_pricing: 'Preisgestaltung',
			cost: 'Einkaufspreis',
			additional_cost: 'Zusätzliche Kosten',
			total_cost: 'Gesamtkosten',
			price: 'Verkaufspreis',
			price_last_minute: 'Verkaufspreis bei Nachbuchung',
			is_limited_in_time: 'Individuelle Zeitangabe',
			available_from: 'Verfügbar von',
			available_until: 'Verfügbar bis',
			brief_description: 'Kurz-Beschreibung',
			description: 'Beschreibung',
			category: 'Kategorie',
			article_category: 'Kategorie',
			subcategory: 'Unterkategorie',
			module: 'Modul',
			seller: 'Anbieter/in',
			team_id: 'Anbieter/in',
			image: '',
			ordered_sum: '# Bestellmenge',
			offered_by_id: 'Angeboten von',
			dependent_articles: 'Benötigte Artikel',
			order_notification: 'Nachricht beim Hinzufügen zum Warenkorb',
			order_description: 'Abfrage zur Bestellinformation',
			files: 'Dateien',
			image_upload_text: 'Neues Artikelbild hochladen',
			show_file_upload: 'Daten hochladen aktivieren',
		},
		article_categories: {
			id: 'Id',
			name: 'Name',
			articles_count: '# Artikel',
			description: 'Beschreibung',
		},
		cart: {
			id: 'Id',
			name: 'Verwendungszweck',
			location: 'Einsatzort',
			required_from: 'Anreise am, Einsatzbeginn',
			required_until: 'Abreise am, Einsatzende',
			company: 'Firma',
			firstname: 'Vorname',
			lastname: 'Nachname',
			email: 'E-Mail',
			mobilenumber: 'Mobilfunknummer',
			user_id: 'User ID',
			created_at: 'Erstellt am',
			created_by_user_id: 'Erstellt von',
			total_price: 'Gesamtsumme',
			order_status: 'Bestellstatus',
			ordered_at: 'Bestelldatum',
			user_avatar: '',
			user_name: 'User',
			team_name: 'Team',
			location_id: 'Einsatzort',
			orderdetails: 'Bestellungsdetails',
			contactperson: 'Ansprechpartner/in vor-Ort',
			articleoverview: 'Artikelübersicht',
			pos: 'Pos.',
			articlename: 'Artikelname',
			amount: 'Anzahl',
			item_price: 'Einzel-Preis',
			price: 'Preis',
			factor: 'Faktor',
			order_now: 'Kostenpflichtig bestellen',
			required_from_until: 'Einsatzzeitraum',
			state: 'Status',
			order_progress: 'Bestellbestätigungen',
			delivery_progress: 'Lieferstatus',
			ordered_by_user_id: 'Besteller/in',
			offered_by_id: 'Angeboten von',
			team_id: 'Team',
			total_confirmed_price: 'Bestätigte Gesamtsumme',
		},
		cartItem: {
			id: 'Id',
			name: 'Artikelname',
			required_from: 'Benötigt ab',
			required_until: 'Benötigt bis',
			quantity_unit: 'Anzahl',
			quantity_factor: 'Faktor',
			price: 'Einzel-Preis',
			total_price: 'Preis',
			order_description: 'Bestellinformation',
			state: 'Status',
			refused_reason: 'Begründung der Absage',
			refused_message: 'Nachricht an Besteller/in',
			delivered_at: 'Geliefert am',
			delivered_message: 'Notiz zur Lieferung',
		},
		location: {
			id: 'Id',
			name: 'Name',
			external_id: 'Externe Id',
			description: 'Beschreibung',
			carts_count: '# Best.',
			teams_count: '# Teams',
			coordinates: 'Koordinaten',
		},
		team: {
			pivot: { number: 'Zeichen', is_seller: 'Anbieter/in', budget: 'Budget' },
			legal_name: 'Firmierung',
			street: 'Straße',
			street_number: 'Hausnummer',
			zip: 'PLZ',
			city: 'Stadt',
			country: 'Land',
			vat_number: 'USt-IdNr.',
			tax_number: 'Steuernummer',
			contact_mobile: 'Mobil (Kontakt)',
			articles_count: '# Angeb. Artikel',
			carts_count: '# Ausg. Best.',
			locations_count: '# Einsatzorte',
			cost_sum: 'Einkaufspreis',
			gross_sum: 'Abrechnung',
		},
		event: {
			ordering_start_at: 'Bestellstart',
			ordering_end_at: 'Bestellschluss',
			company_name: 'Firmenname',
			street: 'Straße',
			street_number: 'Hausnummer',
			postalcode: 'PLZ',
			city: 'Stadt',
			delivery_note_intro: 'Einleitungstext',
			delivery_note_footer: 'Fußzeile',
			delivery_note_show_prices: 'Preise anzeigen',
			delivery_note_show_signature: 'Unterschriftsfelder anzeigen',
		},
		event_team_pivot: {
			budget: 'Budget',
			custom_ordering: 'Individueller Bestellzeitraum',
			custom_article_categories: 'Eingeschränkte Artikel Kategorien',
		},
	},
	enums: {
		article_fixed_pricing: {
			true: 'Berechnung im Shop',
			false: 'Preis auf Anfrage',
		},
		article_unit: {
			null: '',
			piece: 'Stück',
			pack: 'Packung',
			person: 'Person',
			area_qm: 'm²',
			undefined: '?',
		},
		article_factor: {
			null: '',
			event: 'Veranstaltung',
			day: 'Tag',
			hour: 'Stunde',
			undefined: '?',
		},
		article_dependency_mode: {
			once: 'Artikel einmalig benötigt',
			each: 'Artikel je Stück benötigt',
		},
		order_state: {
			open: 'Offen',
			ordered: 'Bestellt',
		},
		cart_item_refused_reason: {
			availability: 'Die Position ist nicht mehr verfügbar',
			feasibility: 'Die Umsetzung ist nicht möglich',
			responsibility: 'Wir sind nicht zuständig für die Position',
			others: 'Sonstige Gründe',
		},
		// Die Namen der Zustände aus @/utils/cartItemState, kurz genug für die Legende unter der Tabelle
		cart_item_state: {
			open: 'Offen',
			waiting_for_price: 'Wartet auf Preis',
			waiting_for_seller: 'Preis zu bestätigen',
			confirmed: 'Bestätigt',
			partially_confirmed: 'Geändert und Bestätigt',
			canceled: 'Abgesagt',
		},
		cart_item_delivery_state: {
			open: 'Noch nicht geliefert',
			delivered: 'Geliefert',
		},
	},
	tabs: {
		order_review: {
			review: 'Bestellung',
			notes: 'Eigene Notizen',
		},
		article_settings: {
			general: 'Allgemein',
			preview: 'Vorschau',
			orders: 'Bestellungen',
			order_items: 'Bestellpositionen',
			notes: 'Notizen',
		},
		admin_settings: {
			article_categories: 'Artikel Kategorien',
			groups: {
				shop: 'Shop',
			},
		},
		team_settings: {
			general: 'Allgemein',
		},
		event_settings: {
			general: 'Allgemein',
			announcements: 'Ankündigungen',
			users: 'Personen',
			teams: 'Teams',
			locations: 'Einsatzorte',
			delivery_note: 'Lieferschein',
			import: 'Import',
		},
	},
	popovers: {
		order_state: {
			open: {
				title: 'Bestellung im Warenkorb',
				text: 'Die Bestellung wurde noch nicht bestätigt. Die Ariktel sind noch im Warenkorb.',
			},
			ordered: {
				title: 'Bestellung aufgegeben',
				text: 'Die Bestellung wurde bestätogt. Die Artikel wurden gebucht.',
			},
		},
		article: {
			is_pickup: {
				title: 'Selbstabholung',
				text: 'Gibt an, ob der Artikel auf der Veranstaltung direkt am Lieferort zur Verfügung gestellt wird oder an einer zentralen Stelle (Helpdesk oder Festivaloffice) selbst abgeholt werden muss.',
			},
			is_shown: {
				title: 'Im Shop anzeigen',
				text: 'Gibt an, ob der Artikel den Bestellenden im Shop direkt zum ordern angezeigt, oder er verdeckt angelegt wird, um ihn bei Bedarf den Bestellungen durch den Anbietenden hinzuzufügen. Diese Einstellung wird auch bei "benötigten Produkten" notwendig.',
			},
			is_individual: {
				title: 'Als mehrere Positionen im Warenkorb',
				text: 'Gibt an, ob der Artikel im Warenkorb als eine Position mit Menge oder als mehrere einzelne Positionen hinzugefügt wird. Das ist gegebenenfalls sinnvoll für Sonderanfragen oder Artikel mit individueller Zeitangabe.',
			},
			has_fixed_pricing: {
				title: 'Preisgestaltung',
				text: 'Gib an, ob der Preis direkt im Shop berechnet wird, oder ob der Preis nach der Bestellung auf Anfrage berechnet wird.',
			},
			cost: {
				title: 'Einkaufspreis',
				text: 'In dem Feld ist der Wert anzugeben den der Artikel dem Veranstalter kostet.',
			},
			additional_cost: {
				title: 'Zusätzliche Kosten',
				text: 'In dem Feld sollen die zusätzlichen externen Kosten eingetragen werden die ein Produkt benötigt. Dazu gehören z.B. Lieferkosten.',
			},
			price: {
				title: 'Verkaufspreis',
				text: 'In dem Feld ist der Wert anzugeben, für den der Artikel auf der Veranstaltung mit Marge (mindestens 20% in Absprache mit dem Veranstaltenden) angeboten wird.',
			},
			price_last_minute: {
				title: 'Verkaufspreis bei Nachbuchung',
				text: 'In dem Feld ist der Wert anzugeben, für den der Artikel auf der Veranstaltung mit Marge (mindestens 20%) angeboten wird, wenn dieser nach der Buchungsfrist bestellt wird.',
			},
			dependent_articles: {
				title: 'Benötigte Artikel',
				text: 'Sollte der Artikel nur in Kombination mit einem anderen Produkt einsetzbar sein, so kann dieser benötigte Artikel hier verknüpft werden.',
			},
			is_limited_in_time: {
				title: 'Individuelle Zeitangabe',
				text: 'Gibt an ob eine individuelle Zeitangabe für die Bestellung des Artikels gesetzt werden soll. Diese Option sollte für alle Artikel genutzt werden die nichtden gesamten Produktionszeitraum zur Verfügung gestellt werden., z.B. PKWs, Fahrräder, oder Pflanzen.',
			},
			available_from: {
				title: 'Verfügbar von',
				text: 'Gibt bei einer individuellen Zeitangabe an, ab wann der Artikel für die Buchung verfügbar ist.',
			},
			available_until: {
				title: 'Verfügbar bis',
				text: 'Gibt bei einer individuellen Zeitangabe an, bis wann der Artikel für die Buchung verfügbar ist.',
			},
			order_notification: {
				title: 'Nachricht beim Hinzufügen zum Warenkorb',
				text: 'Diese Einstellung kann verwendet werden um individuelle Nachrichten beim Hinzufügen des Artikels in den Warenkorb anzuzeigen, z.B. wenn ein Führerschein für ein Fahrzeug benötigt wird.',
			},
			order_description: {
				title: 'Benötigt eine Bestellinformation',
				text: 'Wenn diese Einstellung aktiviert ist, muss der/die Nutzer/in eine Information beim Hinzufügen des Artikels zum Warenkorb ausfüllen. Die Angabe was ausgefüllt werden soll, wird hier eingetragen. Diese Einstellung kann z.B. für Farbwünsche genutzt werden.',
			},
			files: {
				title: 'Dateien',
				text: 'Wenn zusätzliche Dateien dem Bestellenden zur Verfügung gestellt werden sollen, so können diese hier bereitgestellt werden.',
			},
			show_file_upload: {
				title: 'Daten hochladen aktivieren',
				text: 'Gibt an ob bein hinzufügen der Artikels eine Dialog zum Hochladen einer Datei angezeigt werden soll.',
			},
		},
		article_cart: {
			is_limited_in_time: {
				title: 'Eingeschränke Verfügbarkeit',
				text: 'Dieser Artikel ist nicht im gesamten Produktionszeitraum verfügbar. Klicke auf den Artikel um die Verfügbarkeit anzuzeigen.',
			},
			dependent_articles: {
				title: 'Benötigte Artikel vorhanden',
				text: 'Dieser Artikel benötigt weitere Artikel. Klicke auf den Artikel um diese anzuzeigen.',
			},
			files: {
				title: 'Dateien vorhanden',
				text: 'Zu diesem Artikel wurden Dateien hinzugefügt. Klicke auf den Artikel um diese anzusehen oder herunterzuladen.',
			},
		},
		shop: {
			article_accepted: {
				title: 'Eigener Artikel zur Bestellung freigeben',
				text: 'Dieser eigene Artikel ist vom Veranstalter für die Bestellung freigegeben.',
			},
			article_published: {
				title: 'Eigener Artikel it zur Veröffentlichung freigeben',
				text: 'Dieser eigene Artikel ist von deinem Team zur Veröffentlichung freigegeben und wartet auf die Freigabe vom Veranstalter.',
			},
			article_pending: {
				title: 'Eigener Artikel',
				text: 'Dieser eigene Artikel ist noch nicht zur Veröffentlichung freigegeben.',
			},
		},
		cart: {
			name: {
				title: 'Verwendungszweck',
				text: 'Der Verwendungszweck soll vergeben werden um bei mehreren Bestellungen innerhalb eines Teams die Zuordnung zu erleichtern.',
			},
			location: {
				title: 'Einsatzort',
				text: 'Der Einsatzort ist die Position auf dem Gelände bei dem die bestellten Artikel benötigt werden. Sollte kein Einsatzort auswählbar sein, kontaktieren Sie bitte ihre/n Ansprechpartner/in.',
			},
			required_from: {
				title: 'Anreise am, Einsatzbeginn',
				text: 'Das Datum dient als Information, ab wann Artikel ohne individuelle Zeitangabe an dem Einsatzort verfügbar sein sollen.',
			},
			required_until: {
				title: 'Abreise am, Einsatzende',
				text: 'Das Datum dient als Information, bis wann Artikel ohne individuelle Zeitangabe an dem Einsatzort verfügbar sein sollen.',
			},
		},
		cart_item: {
			waiting_for_price: {
				title: 'Warenkorb Position wartet auf Preiskalkulation',
				text: 'Für die die Warenkorb Position wird die Preiskalkulation durch den/die Anbieter/in noch durchgeführt.',
			},
			waiting_for_seller: {
				title: 'Warenkorb Position wartet auf Preis Bestätigung',
				text: 'Der Preis für Warenkorb Position ist angegeben. Dieser muss noch doch den/die Erwerber/in bestätigt werden.',
			},
			confirmed: {
				title: 'Warenkorb Position bestätigt',
				text: 'Die Warenkorb Position ist wie bestellt bestätigt.',
			},
			partially_confirmed: {
				title: 'Warenkorb Position eingeschränkt bestätigt',
				text: 'Die Warenkorb Position konnte nur eingeschränkt bestätigt werden.',
			},
			canceled: {
				title: 'Warenkorb Position abgesagt',
				text: 'Die Warenkorb Position wurde abgesagt und kann nicht realisiert werden.',
			},
			delivered: {
				title: 'Warenkorb Position geliefert',
				text: 'Grün hinterlegte Zeilen wurden bereits geliefert. Über die Schaltfläche mit dem LKW wird eine Position als geliefert markiert.',
			},
		},
		event: {
			address: {
				title: 'Adressdaten',
				text: 'Bitte hier die Adresse der Veranstaltung angeben. Sie wird den Teams als Lieferaddresse für die Veranstaltung angezeigt.',
			},
		},
		team: {
			address: {
				title: 'Adressdaten',
				text: 'Bitte hier die Rechnungsadresse für deine Bestellungen angeben, nicht die Adresse der Veranstaltung.',
			},
		},
		invite_team: {
			locations: {
				title: 'Lieferorte',
				text: 'Einsatzorte an die das Team Artikel bestellen kann.',
			},
			budget: {
				title: 'Budget',
				text: 'Maximal verfügbares Budget für das Team. Die Summe der Kosten aller Bestellungen kann diesen Betrag nicht übersteigen.',
			},
		},
	},
	confirms: {
		article_accept: {
			title: 'Artikel zur Bestellung freigeben',
			text: 'Soll der Artikel "{article_name}" zur Bestellung freigegeben werden? Sobald der Artikel bestellt wurde, kann das Produkt nicht mehr in seinen Einstellungen angepasst werden.',
		},
		article_publish: {
			title: 'Artikel zur Veröffentlichung freigeben',
			text: 'Soll der Artikel "{article_name}" zur Veröffentlichung freigegeben werden? Sobald der Artikel durch den Veranstaltenden freigegeben wurde, kann der Vorgang nicht rückgängig gemacht werden.',
		},
		article_publish_info: {
			title: 'Info zur Artikel Veröffentlichung',
			text: 'Der Artikel "{article_name}" kann nicht veröffentlicht werden. Bitte alle notwendigen Informationen im Artikel angeben.',
		},
		delete_article: {
			title: 'Artikel löschen',
			text: 'Soll der Artikel "{name}" wirklich entfernt werden?',
		},
		remove_article_file: {
			title: 'Datei des Artikels löschen',
			text: 'Soll die Datei "{name}" wirklich entfernt werden?',
		},
		order_cart: {
			title: 'Kostenpflichtig bestellen',
			text: 'Den Warenkorb "{name}" jetzt kostenpflichtig bestellen?',
		},
		delete_cart_item: {
			title: 'Warenkorb Position löschen',
			text: 'Soll die Position "{name}" wirklich aus dem Warenkorb entfernt werden?',
		},
		confirm_cart_item: {
			title: 'Warenkorb Position bestätigen',
			text: 'Soll die Position "{name}" bestätigt werden? Dieser Vorgang kann nicht rückgängig gemacht werden.',
		},
		refuse_cart_item: {
			title: 'Warenkorb Position absagen',
			text: 'Soll die Position "{name}" abgesagt werden? Dieser Vorgang kann nicht rückgängig gemacht werden.',
		},
		deliver_cart_item: {
			title: 'Warenkorb Position als geliefert markieren',
			text: 'Soll die Position "{name}" als geliefert markiert werden? Optional kann eine Notiz zur Lieferung hinterlegt werden.',
		},
		accept_pricing: {
			title: 'Preis auf Anfrage annehmen',
			text: 'Den Preis von "{price}" für den Artikel "{name}" annehmen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
		},
		article_notification: {
			title: 'Artikelinformation',
		},
		add_dependend_articles: {
			title: 'Benötigter Artikel hinzufügen',
			text: `Die folgenden Artikel werden für den Artikel "{name}" benötigt. Diese werden automatisch hinzugefügt.`,
		},
	},
	filters: {
		article: 'Artikel',
		article_category: 'Artikel Kategorie',
		article_publication: 'Artikel Vollständigkeit',
		not_released: 'Nicht zur Prüfung freigegeben',
		released_for_review: 'Zur Prüfung freigegeben',
		not_published: 'unvollständig',
		released_for_order: 'Zur Bestellung freigegeben',

		seller: 'Anbieter/in',
		customer: 'Team',
		location: 'Einsatzort',

		order_state: {
			title: 'Bestellstatus',
			value: {
				open: 'Offen',
				ordered: 'Bestellt',
				not_fully_confirmed: 'Nicht vollständig bestätigt',
				fully_confirmed: 'Vollstädnig bestätigt',
			},
		},
		cart_item_state: {
			title: 'Status',
			value: {
				open: 'Offen',
				accepted: 'Bestätigt',
				changed: 'Geändert und Bestätigt',
				canceled: 'Abgesagt',
			},
		},
		delivery_state: {
			title: 'Lieferstatus',
			value: {
				not_delivered: 'Noch nicht geliefert',
				delivered: 'Geliefert',
			},
		},
		delivery_confirmation: {
			title: 'Bestätigung',
			value: {
				confirmed: 'Nur bestätigte',
				all: 'Alle',
			},
		},
	},
	notifications: {
		article_accepted: {
			icon: 'fa-check-double',
			title: 'Artikel zur Bestellung freigeben',
			text: "Dein Artikel '{article_name}' wurde durch den Veranstalter zur Bestellung freigegeben.",
		},
		order_created_to_buyer: {
			icon: 'fa-tasks',
			title: 'Bestellung in Bearbeitung',
			text: "Deine Bestellung '{order_name}' ist eingegangen.",
		},
		order_created_to_seller: {
			icon: 'fa-tasks',
			title: 'Bestellung eingegangen',
			text: "Die Bestellung '{order_name}', mit von dir angeboteten Artikeln, wurde erstellt.",
		},
		cart_item_confirmed: {
			icon: 'fa-check',
			title: 'Warenkorb Position bestätigt',
			text: "Die Warenkob Position '{cart_item_article_name}' wurde bestätigt.",
		},
		cart_item_rejected: {
			icon: 'fa-times',
			title: 'Warenkorb Position abgelehnt',
			text: "Die Warenkob Position '{cart_item_article_name}' wurde abgelehnt.",
		},
		cart_item_article_added: {
			icon: 'fa-plus',
			title: 'Warenkorb Position hinzugefügt',
			text: "Die Warenkob Position '{cart_item_article_name}' wurde hinzugefügt.",
		},
		cart_item_article_switched: {
			icon: 'fa-arrow-up-arrow-down',
			title: 'Warenkorb Position getauscht',
			text: "Die Warenkob Position '{cart_item_article_name}' wurde gegen einen anderen Artikel getauscht.",
		},
	},
	components: {
		occupied_days: {
			note: 'Vom {first} bis {last} hängt schon etwas an der Veranstaltung (Artikel, Bestellungen, Positionen). Der Zeitraum muss diese Tage einschließen.',
		},
	},
};
